import classNames from 'classnames';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Button } from 'atoms/buttons/Button';
import { StarBall } from 'atoms/icons/StarBall';
import { Horizontal } from 'atoms/layout/flex';
import { LabelL } from 'atoms/typography';
import { glossary } from 'lib/glossary';

const Root = styled(Horizontal).attrs({ center: true, gap: 4 })`
  background-color: var(--c-nd-150);
  border-radius: var(--unit);
  padding: var(--unit) var(--triple-unit);

  width: calc(85 * var(--unit));
  overflow: hidden;
  display: flex;
`;

const NavItemsContainer = styled(Horizontal)`
  border: 1px solid var(--c-nd-50);
  border-radius: var(--unit);
  padding: var(--half-unit);

  width: fit-content;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
`;

const NavItem = styled(LabelL).attrs({ bold: true })`
  cursor: pointer;
  border-radius: var(--half-unit);
  padding: var(--unit) var(--double-unit);
  transition: background-color 0.2s ease;

  &.active {
    background-color: var(--c-nd-50);
    padding: var(--unit) var(--double-unit);
  }
`;

const navItems = defineMessages({
  home: {
    id: 'HowToPlay.navbar.signPlayers',
    defaultMessage: 'Sign players',
  },
  about: {
    id: 'HowToPlay.navbar.waysToPlay',
    defaultMessage: 'Ways to play',
  },
  score: {
    id: 'HowToPlay.navbar.scoring',
    defaultMessage: 'Scoring',
  },
  rewards: {
    id: 'HowToPlay.navbar.rewards',
    defaultMessage: 'Rewards',
  },
  gameplayStrategy: {
    id: 'HowToPlay.navbar.gameplayStrategy',
    defaultMessage: 'Gameplay strategy',
  },
  cardScarcities: {
    id: 'HowToPlay.navbar.cardScarcities',
    defaultMessage: 'Card Scarcities',
  },
});

export const Navbar = () => {
  const { hash } = useLocation();
  return (
    <Root>
      <StarBall height={32} width={32} />
      <NavItemsContainer>
        {Object.values(navItems).map(message => {
          const sectionHash = `#${message.id}`;
          return (
            <Link key={message.id} to={sectionHash}>
              <NavItem className={classNames({ active: hash === sectionHash })}>
                <FormattedMessage {...message} />
              </NavItem>
            </Link>
          );
        })}
      </NavItemsContainer>
      <Button size="large">
        <FormattedMessage {...glossary.playNow} />
      </Button>
    </Root>
  );
};
